<template>
    <div class="main_holder analytics">

        <div class="content_holder">

            <div class="content">

                <h2>Analitika</h2>

                <h3>V spodnjem grafu je prikazan delež zaključenih programov za posamezno članico</h3>

                <div class="analytics_content">
                    <div class="analytics_charts">
                        <div class="chart_canvas">
                            <span>Delež zaključenih programov - filtrirani (izključeni so programi vrste izpopolnjevanje, programi v izteku, 
                                FDV programi zaključeni v prejšnjem študijskem letu, brez vpisanih študentov v izbranem študijskem letu)</span>
                            <!-- <horizontal-bar-chart :chart-data="data_collection" :options="chart_options"></horizontal-bar-chart> -->
                            <Graph
                                v-if="fillData('filtered')"
                                :graph_data="fillData('filtered')"
                                :graph_layout="graphLayout"
                                :display_mode_bar="false">
                            </Graph>
                        </div>

                        <div class="chart_canvas">
                            <span>Delež zaključenih programov - vsi, nefiltrirani</span>
                            <!-- <horizontal-bar-chart :chart-data="data_collection" :options="chart_options"></horizontal-bar-chart> -->
                            <Graph
                                v-if="fillData('global')"
                                :graph_data="fillData('global')"
                                :graph_layout="graphLayout"
                                :display_mode_bar="false">
                            </Graph>
                        </div>

                        <!--<div class="chart_canvas">
                            <line-chart :chart-data="data_collection" :options="chart_options"></line-chart>
                        </div>-->
                    </div>

                    <div class="analytics_exports" @mouseleave="hideExportMenu">
                        <div class="export_dropdown" @mouseenter="showExportMenu = true">
                            <div class="export_trigger" @click="toggleExportMenu">
                                <font-awesome-icon :icon="['fas', 'file-arrow-down']" />
                            </div>
                            
                            <div class="export_menu" v-show="showExportMenu">
                                <div class="export_menu_item" @click="exportEvalvationAnalytics({export_type: 'get_zip_programs_data'})"
                                :title="'Oddana poročila programov ' + year">
                                    <font-awesome-icon :icon="['far', 'file-archive']" />
                                    <span>Oddana poročila programov {{ year }}</span>
                                </div>

                                <div class="export_menu_item" @click="exportEvalvationAnalytics({export_type: 'get_excel_programs'})"
                                :title="'Seznam programov ' + year">
                                    <font-awesome-icon :icon="['far', 'file-excel']" />
                                    <span>Seznam programov {{ year }}</span>
                                </div>

                                <div class="export_menu_item" @click="exportEvalvationAnalytics({export_type: 'get_excel_timestamps'})"
                                :title="'Časi odgovorov ' + year">
                                    <font-awesome-icon :icon="['far', 'file-excel']" />
                                    <span>Časi odgovorov {{ year }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
  
</template>

<script>
import { mapActions } from 'vuex';
import { color_main } from '../../scss/basic/colors.scss'

import Graph from "@/components/general/Graph.vue";

export default {
    components: {
        Graph,
    },
    data() {
        return {
            graphLayout: {
                showlegend: false,
                width: 800,
                height: 800,
                title: null,
                margin: {
                    t: 30,
                    l: 50,
                    r: 50,
                },
                xaxis: {
                    range: [1, 119],
                    dtick: 20,
                },
                yaxis: {
                    type: 'category',
                    dtick: 1,
                    tickfont: {
                        size: 16, // Adjust the font size of y-axis labels
                    },
                    automargin: true, // Adjust the margin to fit the larger y-axis labels
                    ticklen: 5, // Adjust the length of ticks on the y-axis
                    tickwidth: 0, // Adjust the width of ticks on the y-axis
                    showline: false, // Remove the line between ticks on the y-axis
                }
            },
            label_finished_share: 'Delež zaključenih programov',
            chart_image_string: '',
            showExportMenu: false
        };
    },
    /* watch: {
        getStatisticsByFaculty(newVal, oldVal) {
            this.fillData();
        }
    }, */
    computed: {
        year() {
            return this.$store.getters.year;
        },
        getFacultiesNames() {
            return Object.values(this.getStatisticsByFaculty).map(faculty => faculty.name);
        },
        getFacultiesAcronyms() {
            return Object.values(this.getStatisticsByFaculty).map(faculty => faculty.acronym);
        },
        getStatisticsByFaculty() {
            return this.$store.getters.evalvation_statistics_by_faculty;
        },
        sortedStatisticsByFacultyGlobal() {
            if(this.getStatisticsByFaculty.global == null) return [];

            let values = Object.values(this.getStatisticsByFaculty.global);
            return values.sort(function (a, b) {
                if (a.programs_finished_percentage !== b.programs_finished_percentage) {
                    return a.programs_finished_percentage - b.programs_finished_percentage;
                }
                return b.acronym.localeCompare(a.acronym);
            });
        },
        sortedStatisticsByFacultyFiltered() {
            if(this.getStatisticsByFaculty.filtered == null) return [];

            let values = Object.values(this.getStatisticsByFaculty.filtered);
            return values.sort(function (a, b) {
                if (a.programs_finished_percentage !== b.programs_finished_percentage) {
                    return a.programs_finished_percentage - b.programs_finished_percentage;
                }
                return b.acronym.localeCompare(a.acronym);
            });
        },
    },
    methods: {
        ...mapActions([
            'exportEvalvationAnalytics',
            'getEvalvationStatisticsByFaculty'
        ]),
        
        fillData(chart_data) {
            let x = [];
            let y = [];
            let labels = [];

            let CharData = (chart_data == 'global') ? this.sortedStatisticsByFacultyGlobal : this.sortedStatisticsByFacultyFiltered;

            for(let f_data of CharData){
                x.push(f_data.programs_finished_percentage);
                y.push(f_data.acronym);
                labels.push(f_data.programs_finished_percentage+"% ("+f_data.programs_finished+'/'+f_data.programs_all+')');
            }

            return [{
                x: x,
                y: y,
                text: labels,
                textposition: 'outside',
                clip: 'off', // Prevent clipping of text labels
                type: 'bar',
                orientation: 'h',
                hoverinfo: 'none', // Disable hover
                marker: {
                    color: "#E12A26",         // Set the color of the bars
                }, 
                
            }];
        },
        toggleExportMenu() {
            this.showExportMenu = !this.showExportMenu;
        },
        hideExportMenu() {
            this.showExportMenu = false;
        }
    },
    created () {
        //this.fillData();
        this.getEvalvationStatisticsByFaculty();
    },
}
</script>


<style lang="scss" scoped>
</style>
